import logger from '@/utils/debugLogger';
import Fallback from '../Others/AgreementFallback';

const licenseActionMixin = {
  components: {
    Fallback,
  },
  computed: {
    hasErrorInAgreement() {
      return this.$store.state.agreement.hasError;
    },
  },
  mounted() {
    this.checkForPendingServiceWorker()
      .then((hasPendingUpdate) => {
        if (hasPendingUpdate) {
          setTimeout(() => {
            /* eslint no-alert: 0 */
            logger.track.error('User is forced to update application due to viewing license with outdated app.');
            alert([
              'A critical update is required to display the agreement. Your page will be reloaded.',
              '',
              '',
              'If you see this message repeatedly, make sure Viddsee Creator is not opened on another tab.',
            ].join('\n'));
          }, 0);
          location.reload();
        }
      });
  },
  methods: {
    /**
     * Check if a pending update exist
     * @return true if a pending update exist, otherwise false
     */
    checkForPendingServiceWorker() {
      if (window.userRefusedToUpdate) {
        return Promise.resolve(true);
      }

      if ('serviceWorker' in navigator) {
        return navigator.serviceWorker.getRegistrations()
          .then((registrations) => {
            const hasPendingUpdate = registrations.some(({ installing, waiting }) => (installing || waiting));
            return hasPendingUpdate;
          });
      } else {
        return Promise.resolve(false);
      }
    },
  },

  functionalMethods: {
    generateFormData(formFieldProp, formDefaultValue = {}) {
      // Make form data
      const formFieldPrefiller = Object.keys(formFieldProp)
        .reduce((acc, formFieldName) => {
          const formKeyValuePair = formFieldProp[formFieldName];
          acc[formKeyValuePair.key] = formKeyValuePair.value;
          return acc;
        }, {});

      const resolvedConflictedFormObject = Object.keys(formFieldPrefiller)
        .reduce((acc, fieldName) => {
          // if value for key is already defined, do nothing
          if (formDefaultValue[fieldName] !== undefined) return acc;
          // Otherwise, prefill with value from prefiller
          acc[fieldName] = formFieldPrefiller[fieldName];
          return acc;
        }, {});

      return ({
        ...formDefaultValue,
        ...resolvedConflictedFormObject,
      });
    },

    generateFormDefinition(formFieldProp, vueInstance, propertyName) {
      return Object.keys(formFieldProp)
        .reduce((acc, formFiledName) => {
          const formKeyValuePair = formFieldProp[formFiledName];
          acc[formFiledName] = {
            value: vueInstance[propertyName][formKeyValuePair.key],
          };
          return acc;
        }, {});
    },
  },
};

export default licenseActionMixin;



// WEBPACK FOOTER //
// ./src/components/Licenses/mixins/licenseParentMixin.js